import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M22.58,10.06H9.42a2.65,2.65,0,0,0-2.65,2.65V27.18a2.66,2.66,0,0,0,2.65,2.66H22.58a2.66,2.66,0,0,0,2.65-2.66V12.71A2.65,2.65,0,0,0,22.58,10.06ZM9.42,11.36H22.58a1.35,1.35,0,0,1,1.35,1.35V24.4H8.07V12.71A1.35,1.35,0,0,1,9.42,11.36ZM22.58,28.53H9.42a1.35,1.35,0,0,1-1.35-1.35V25.7H23.93v1.48A1.35,1.35,0,0,1,22.58,28.53Z' }),
  React.createElement('path', { d: 'M11.46,7.25h9.08a2.55,2.55,0,0,0,0-5.09H11.46a2.55,2.55,0,0,0,0,5.09Zm0-3.79h9.08a1.25,1.25,0,0,1,0,2.49H11.46a1.25,1.25,0,0,1,0-2.49Z' }),
  React.createElement('path', { d: 'M24.8,8H7.2a.65.65,0,1,0,0,1.3H24.8a.65.65,0,0,0,0-1.3Z' })
));